import { Accordion, Alert, AttachmentCommonUpload, Callout, Card, Col, EventHandler, InputField, Label, PrimaryButton, RadioContainer, Rating, Row, SwitchToggle, Tooltip } from "client/CommonComponents"
import "./AssetInformation.scss"
import informationImage from "../../../../../../../assets/images/Rating Info.svg";
import { formatPrice, isNumber, isNumberWithOneDecimal, isNumberWithoutDecimal } from 'utils'
import RatingInfo from "../../TransferAsset/RatingInfo";
import { CONSTANTS } from '../../../../../../../utils/constants'
import plus from '../../../../../../../assets/images/Plus New.svg'
import deleteOrder from '../../../../../../../assets/images/Delete New.svg';
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";
import dipositionValidation from "../dispositionValidation";
import AssetNumber from "client/Components/OrderManagement/AssetNumber/AssetNumber-Container";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import GetAttachmentView from "client/CommonComponents/AttachmentView";
import permissions, { isAuthorized } from "client/utils/Permissions";
const { ATTACHMENTS_TOOLTIP_CONTENT } = CONSTANTS

const InformativeField = ({ label, value }: any) => (
    <div className="info-wrapper">
        <div className="label">{label}</div>
        <div className="value">{value}</div>
    </div>
);
const ratingContent = [
    {
        ratingValue: 1,
        value: 'Poor (1)'
    },
    {
        ratingValue: 2,
        value: 'Fair (2)'
    },
    {
        ratingValue: 3,
        value: 'Good (3)'
    },
    {
        ratingValue: 4,
        value: 'Very Good (4)'
    },
    {
        ratingValue: 5,
        value: 'New / Excellent (5)'
    }
]
const Informations = (props: any) => {
    const {
        attachmentsList,
        assetDetailList,
        onClickAdd,
        onChangeOdometerHourMeter,
        onChangeEstimatedDispositionPrice,
        onChangeOverallCondition,
        onChangeOverallConditionComment,
        priceFormat,
        onClickDelete,
        onClickAddAsset,
        onUploadClick,
        error,
        setError,
        onClicktLinkAttachment,
        isAttachmentBtnClicked,
        getLinkedAttachmentsCount,
        onCloseLinkAttachment,
        onChangeLinkAttachment,
        list,
        setList,
        onRemoveClick,
        dispositionData,
        docList,
        getOdometerLabel,
        getVinSerialLabel,
        assets,
        Popupcontent,
        hideDialog,
        addNewAssetAlert,
        hideDialogAsset,
        setAssetDetailList,
        setIsAssetBtnClicked,
        isAssetBtnClicked,
        DispositionAssetFieldRef,
        isAddAssetClicked,
        setIsAsserNumberValid,
        setIsAddAssetClicked,
        showDispositionInfoAlert,
        hideDialogAddDisposition,
        isGetAssetInfoCicked,
        WarningPopupcontent,
        warningHideDialog,
        assetStatusList,
        onRadioButtonChange,
        isHourMeterField,
        formatOdometerOnBlur
    } = props;


    const childItems: any = [];

    assetDetailList?.forEach((asset: any, index: any) => {
        const toolTipOverallCondition = {
            onRenderContent: () => {
                return <RatingInfo isOverAllCondition={true} RatingValue={Number(asset?.conditionRating)} />
            }
        }
        const childItem = {
            headerText: (
                <div className={`heading-container ${asset.isExist ? 'added-to-cart' : 'not-added-to-cart'}`}>
                    <div className='heading-container-subItem'>
                        <span><b>ITEM # :{index + 1}</b></span>
                    </div>
                    <div className='right-heading-dispostion'>
                        {asset.isValid ? '' : <span className="error-reason me-2">Asset is  required</span>}
                        <EventHandler onEvent={() => onClickDelete(asset)} data-attribute="AssetInformation_Default_EventHandler">
                            <img src={deleteOrder} alt='Delete Order' className='me-2' />
                        </EventHandler>
                    </div>
                </div>
            ),
            content: <>
                <Row>
                    <Col xs={12} md={4} lg={4} className='mt-0 mb-3'>
                        <AssetNumber
                            order={asset}
                            setOrder={setAssetDetailList}
                            addToCart={isAddAssetClicked}
                            setAddToCart={setIsAddAssetClicked}
                            setIsAsserNumberValid={setIsAsserNumberValid}
                            assetDetailList={assetDetailList}
                            setIsAssetBtnClicked={setIsAssetBtnClicked}
                            isAssetBtnClicked={isAssetBtnClicked}
                            inputRef={(element: any) => DispositionAssetFieldRef.current[0] = element}
                        />
                    </Col>
                    {asset?.glCategory !== CONSTANTS.TRAILERS &&
                        <Col xs={12} md={4} lg={4} className='mb-3'>
                            <Label required data-attribute="AssetInformation_Default_Label_65">{getOdometerLabel(asset)}</Label>
                            <InputField
                                className={asset?.odometerHourMeterError?.length > 0 ? 'controlValidation asset-number-input' : 'asset-number-input'}
                                value={asset?.odometerHourMeter}
                                onChange={(item: any) => onChangeOdometerHourMeter(item, asset)}
                                onBlur={(event: any) => formatOdometerOnBlur(event, asset)}
                                onKeyPress={(event: any) => {
                                    isHourMeterField(asset) 
                                      ? isNumberWithoutDecimal(event)
                                      : isNumberWithOneDecimal(event)
                                  }}
                             data-attribute="AssetInformation_Default_Input" />
                            {asset?.odometerHourMeterError ? <p className='validMessage'>{asset?.odometerHourMeterError}</p> : ""}
                        </Col>
                    }
                    <Col xs={12} md={4} lg={4} className='mb-3'>
                        <Label required data-attribute="AssetInformation_Default_Label_2_3">Estimated Disposition Price</Label>
                        <InputField
                            placeholder="0.00"
                            onBlur={(event: any) => priceFormat(event, asset)}
                            prefix={"$"}
                            value={asset?.estimatedDispositionPrice ? asset?.estimatedDispositionPrice : ''}
                            onChange={(item: any) => { onChangeEstimatedDispositionPrice(item, asset); isNumber(item); }}
                            onKeyPress={(event: any) => { isNumber(event) }}
                            className={asset?.estimatedDispositionPriceError?.length > 0 ? 'controlValidation asset-number-input' : 'asset-number-input'}
                         data-attribute="AssetInformation_Default_Input_2" />
                        {asset?.estimatedDispositionPriceError ? <p className='validMessage'>{asset?.estimatedDispositionPriceError}</p> : ""}
                    </Col>
                </Row>
                <Row className="mx-0">
                    <Col xs={12} sm={8} md={8} lg={8} className='mb-3 mb-sm-0'>
                        <Row>
                            <div className="asset-information-block px-0">
                                <Label data-attribute="AssetInformation_Default_Label_3_3">Asset Information</Label>
                                <div className="disposition-link-attachment-item">
                                    <EventHandler onEvent={(e: any) => { onClicktLinkAttachment(e, index) }} data-attribute="AssetInformation_Default_EventHandler_2">
                                        <span id={"link_attachment_" + index} className={`link-attachment me-0 mb-2 ${asset?.isAttachmentsRequired ? 'link-attachment-error' : ''}`}>
                                            <span className={'fa fa-paperclip attachment-img'}> </span> Link Attachment to Item ({getLinkedAttachmentsCount(asset)})
                                        </span>
                                    </EventHandler>
                                    <span className="attachment-link-star required">{!dipositionValidation.choices.includes(dispositionData?.assetDispositionChoice) ? '*' : ''} </span>
                                    {isAttachmentBtnClicked?.[index] && (
                                        <Callout
                                            targetId={"link_attachment_" + index}
                                            toggleIsCalloutVisible={(e: any) => { onClicktLinkAttachment(e, index) }}
                                            calloutMaxHeight={300}
                                         data-attribute="AssetInformation_Default_Callout">
                                            <GetAttachmentView attachmentsList={attachmentsList} onCloseLinkAttachment={onCloseLinkAttachment} onChangeLinkAttachment={onChangeLinkAttachment} itemType={asset} />
                                        </Callout>
                                    )}
                                </div>
                            </div>
                            <div className="asset-info-section disposition mt-0">
                                {
                                    <>
                                        <Row>
                                            <Col xs={12} sm={6} md={4} lg={4} className='mb-0'>
                                                <InformativeField label="Unit#" value={(asset?.unitNumber != null && asset?.unitNumber?.trim()?.length != 0) ? asset?.unitNumber : '-'} />
                                                <InformativeField label="Description" value={(asset?.description != null && asset?.description?.trim()?.length != 0) ? asset?.description : '-'} />
                                                <InformativeField label="Color" value={(asset?.color != null && asset?.color?.trim()?.length != 0) ? asset?.color : '-'} />
                                                <InformativeField label={getVinSerialLabel(asset)} value={(asset?.serialNumber != null && asset?.serialNumber?.trim()?.length != 0) ? asset?.serialNumber : '-'} />
                                                <InformativeField label="Monthly Payment" value={(typeof asset?.monthlyAmount == "number" && asset?.monthlyAmount != null) ? `$${parseFloat(`${asset?.monthlyAmount}`).toFixed(2)}` : '-'} />
                                                <InformativeField label="Months Remaining" value={asset?.monthRemaining != null ? asset?.monthRemaining : '-'} />
                                            </Col>
                                            <Col xs={12} sm={6} md={4} lg={4} className='mb-0'>
                                                <InformativeField label="Year" value={(asset?.modelYear == null || asset?.modelYear == undefined || asset?.modelYear == "") ? '-' : asset?.modelYear} />
                                                <InformativeField label="Equipment Status" value={(asset?.eqStatusDesc != null && asset?.eqStatusDesc?.trim()?.length != 0) ? asset?.eqStatusDesc : '-'} />
                                                <InformativeField label="Equipment Class" value={(asset?.equipmentClassDesc != null && asset?.equipmentClassDesc?.trim()?.length != 0) ? asset?.equipmentClassDesc : '-'} />
                                                <InformativeField label="License #" value={(asset?.licensePlateNumber != null && asset?.licensePlateNumber?.trim()?.length != 0) ? asset?.licensePlateNumber : '-'} />
                                                <InformativeField label="Net Booked Value" value={(typeof asset?.netBookedValue == "number" && asset?.netBookedValue != null) ? `$${formatPrice(asset?.netBookedValue, 2)}` : '-'} />
                                                <InformativeField label="Depreciation Start Date" value={asset?.dateAcquired != null ? asset?.dateAcquired : '-'} />
                                            </Col>
                                            {props?.globalPenaltyFlag &&
                                                <Col xs={12} sm={6} md={4} lg={4} className='mb-0 pe-0'>
                                                    <InformativeField label="Disposition Penalty Fee" value={asset?.dispositionPenalityFee ? `$${formatPrice(asset?.dispositionPenalityFee, 2)}` : "$0.00"} />
                                                    <InformativeField label="Replacement Fleet Asset Order #" value={asset?.ReplacementFleetAssetOrderNo ? asset?.ReplacementFleetAssetOrderNo : "N/A"} />
                                                    <InformativeField label="Replacement Fleet Asset #" value={asset?.replacementFleetAssetNo ? asset?.replacementFleetAssetNo : "N/A"} />
                                                </Col>
                                            }
                                        </Row>
                                    </>
                                }
                            </div>
                        </Row>
                    </Col>
                    <Col xs={12} md={4} lg={4} className='px-0 ps-sm-3 ps-sm-0'>
                        <Row>
                            <Col xs={12} md={12} lg={12} className={`mb-3 ${asset?.glCategory !== CONSTANTS.TRAILERS ? '' : 'remove-odometer'}`}>
                                <Label required className="mb-0" data-attribute="AssetInformation_Default_Label_4_3">Overall Condition</Label>
                                <div className='rating-info'>
                                    <div>
                                        <Rating rating={asset?.conditionRating} onChange={(item: any, rating: any) => onChangeOverallCondition(item, rating, asset)} allowZeroStars  data-attribute="AssetInformation_Default_Rating_4" />
                                        {
                                            ratingContent.map((item: any, _index: any) => {
                                                return (
                                                    <>
                                                        {asset?.conditionRating == item.ratingValue ? <span className="text-rating">{item.value}</span> : null}
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <Tooltip tooltipProps={toolTipOverallCondition} id='RatingTooltip' data-attribute="AssetInformation_Default_Tooltip_62">
                                        <img src={informationImage} alt="info" title='Rating Info' className="rating-tooltip rating_img" />
                                    </Tooltip>
                                </div>
                                {asset?.overallConditionError ? <p className='validMessage'>{asset?.overallConditionError}</p> : ""}
                                <span className="comment-star">
                                    ("Comment" is required, If less than or equals 3 star)
                                </span>
                            </Col>
                            <Col xs={12} md={12} lg={12} className="mb-3">
                                <Label required={asset?.conditionRating <= 3} data-attribute="AssetInformation_Default_Label_5_3">Overall Condition Comment</Label>
                                <InputField
                                    name='conditionComment'
                                    multiline={true}
                                    row={6}
                                    resizable={false}
                                    value={asset?.conditionComment}
                                    onChange={(item: any) => { onChangeOverallConditionComment(item, asset) }}
                                    className={'conditionalComment-disposition ' + (asset?.overallConditionCommentError?.length ? "controlValidation" : "")}
                                 data-attribute="AssetInformation_conditionComment_Input" />
                                {asset?.overallConditionCommentError ? <p className='validMessage'>{asset?.overallConditionCommentError}</p> : ""}
                            </Col>
                            {asset?.showAssetStatus ?
                                <>
                                    <Col xs={6} md={6} lg={6} sm={5} className="mb-3">
                                        <Label required data-attribute="AssetInformation_Default_Label_6_3">Asset Status</Label>
                                        <RadioContainer
                                            id={asset?.assetIndex}
                                            selectedKey={asset?.assetStatus}
                                            options={assetStatusList}
                                            onChange={(e: any, item?: any) => { onRadioButtonChange(e, item, asset) }}
                                            className={'inside-radioBtn ' + (asset?.assetStatusError?.length ? "controlValidation" : "")}
                                         data-attribute="AssetInformation_Default_Radio_3" />
                                        {asset?.assetStatusError ? <p className='validMessage'>{asset?.assetStatusError}</p> : ""}
                                    </Col>
                                    <Col xs={6} md={6} lg={6} sm={7} className="mb-3 asset-Status status-responsive">
                                        {assetStatusList?.map((item?: any, index?: any) => {
                                            const toolTipAssetStatus = {
                                                onRenderContent: () => {
                                                    return <RatingInfo isOverAllCondition={false} RatingValue={item?.text} />
                                                }
                                            }
                                            return (
                                                <>
                                                    <Tooltip tooltipProps={toolTipAssetStatus} id='RatingTooltip' data-attribute="AssetInformation_Default_Tooltip_2_3">
                                                        <img src={informationImage} alt="info" title='Asset Status Info' className="rating-tooltip" />
                                                    </Tooltip>
                                                </>
                                            )
                                        })}

                                    </Col>
                                </>
                                : null}
                        </Row>
                    </Col>
                </Row >
            </>,
            uuid: `AssetInformation_Item_${index}`,
            key: asset?.assetIndex
        };
        childItems.push(childItem);
    });

    //sorting child items(reasons) as last in first out order
    const sortedChildItemsLIFO = childItems?.sort((a: any, b: any) => b?.key - a?.key)

    return (
        <div className="item-details-requisition disposition mt-3 mb-3">
            <Card data-attribute="AssetInformation_Default_Card">
                <div className='header border-bottom'>
                    <div className="left-content">
                        <p className='headingText'>ASSET INFORMATION <span>({assetDetailList?.length})</span></p>
                        <p className='subText enter-asset'>Enter Asset #</p>
                    </div>
                    <div className="right-content">
                        <div className="asset-qty asset-qty-disposition">
                            <EventHandler onEvent={(item: any) => onClickAdd(item)} data-attribute="AssetInformation_Default_EventHandler_3">
                                <img className="add-asset-button-plus" src={plus} alt="add asset" />
                            </EventHandler>
                            <div className={`attachment-container ms-2 ${dispositionData?.assetDispositionChoiseAttatmentNote ? 'mt-0' : 'mt-2'}`}>
                                <div className="pull-right">
                                    <AttachmentCommonUpload
                                        link={true}
                                        list={list}
                                        uploadedList={docList}
                                        setList={setList}
                                        multiple={true}
                                        uploadBtnClick={onUploadClick}
                                        error={error}
                                        setError={setError}
                                        maxSize={5}
                                        onRemove={onRemoveClick}
                                        isAttachmentsRequired={!dipositionValidation.choices.includes(dispositionData?.assetDispositionChoice)}
                                        tooltipConent={ATTACHMENTS_TOOLTIP_CONTENT}
                                        iAttachmentEditable={true}
                                        isDownloadable={false}
                                        disabled={!isAuthorized(permissions.CreateUpdateTransfers)}
                                     data-attribute="AssetInformation_Default_AttachmentCommonUpload" />
                                </div>
                            </div>
                        </div>
                        {dispositionData?.assetDispositionChoiseAttatmentNote ? <p className='note-diposition-msg attachments'><span>Note - </span>{dispositionData?.assetDispositionChoiseAttatmentNote}</p> : dispositionData?.uploadAttachmentsError && <p className='validMessage'>{dispositionData?.uploadAttachmentsError}</p>}
                    </div>
                    {
                        addNewAssetAlert &&
                        <Alert
                            className="alert-message warningAlert"
                            showAlert={addNewAssetAlert}
                            dismissAlert={hideDialogAsset}
                            type="warning"
                            text="New Asset Quantity added."
                         data-attribute="AssetInformation_Default_Alerts" />
                    }
                </div>
                <Accordion
                    Items={sortedChildItemsLIFO}
                    className="item-detail-accordion asset-information-accordion"
                    preExpanded={[`AssetInformation_Item_0`]}
                 data-attribute="AssetInformation_Default_Accordion_2" />
                <Row className='mb-1'>
                    <Col xs={12} sm={12} md={12} lg={12} className='mt-0'>
                        <div className='pull-right addasset-btn'>
                            <Alert
                                className="alert-message warningAlert"
                                showAlert={showDispositionInfoAlert}
                                dismissAlert={hideDialogAddDisposition}
                                type="warning"
                                text={isGetAssetInfoCicked ? "Asset updated successfully" : "Asset added successfully"}
                             data-attribute="AssetInformation_Default_Alerts_2" />
                            {/* <OutlineButton text='Cancel'  data-attribute="AssetInformation_Default_Button" /> */}
                            <PrimaryButton text={assets?.length > 0 ? "Update Asset" : 'Add Asset'} onClick={onClickAddAsset} disabled={!isAuthorized(permissions.CreateUpdateTransfers)}  data-attribute="AssetInformation_Default_Button_2" />
                        </div>
                    </Col>
                </Row>
            </Card>
            {Popupcontent.isDialogVisible ? <CompleteConfirmationPopup
                hideDialog={!Popupcontent.isDialogVisible}
                onDismiss={hideDialog}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
            /> : ""}
            {WarningPopupcontent.isDialogVisible ?
                <CancelConfirmationPopup
                    hideDialog={!WarningPopupcontent.isDialogVisible}
                    onDismiss={warningHideDialog}
                    Popupcontent={WarningPopupcontent}
                    popupOutlinebtnOnclick={() => WarningPopupcontent.popupOutlinebtnOnclick()}
                    popupPrimarybtnOnclick={() => WarningPopupcontent.popupPrimarybtnOnclick()}
                    className='penalty-warning-popup'
                /> : ""}
        </div>
    )

}

export default Informations
